import React from 'react'
import { Row, Col } from 'react-bootstrap'

const OrderChangeStatus = ({ workingStatus, onClick, defaultStatus }) => {
  return (
    <Row>
      <Col>
        <div className="btn-group" style={{ width: '100%' }}>
          {defaultStatus !== 'receipt attached' && (
            <div
              className={workingStatus === 'pending' ? 'btn btn-warning' : 'btn btn-outline-warning'}
              style={{ padding: '8px' }}
              onClick={() => onClick({ color: 'bg-warning', status: 'pending' })}
            >
              รอชำระเงิน
            </div>
          )}
          <div
            className={workingStatus === 'receipt attached' ? 'btn btn-info' : 'btn btn-outline-info'}
            style={{ padding: '8px' }}
            onClick={() => onClick({ color: 'bg-info', status: 'receipt attached' })}
          >
            แนบสลิปแล้ว
          </div>
          <div
            className={workingStatus === 'success' ? 'btn btn-success' : 'btn btn-outline-success'}
            style={{ padding: '8px' }}
            onClick={() => onClick({ color: 'bg-success', status: 'success' })}
          >
            ซื้อสำเร็จ
          </div>
          <div
            className={workingStatus === 'cancelled' ? 'btn btn-danger' : 'btn btn-outline-danger'}
            style={{ padding: '8px' }}
            onClick={() => onClick({ color: 'bg-danger', status: 'cancelled' })}
          >
            ยกเลิก
          </div>
        </div>
      </Col>
    </Row>
  )
}

export default OrderChangeStatus
